import { render, staticRenderFns } from "./myMain.vue?vue&type=template&id=1ede5c25&scoped=true"
import script from "./myMain.vue?vue&type=script&lang=js"
export * from "./myMain.vue?vue&type=script&lang=js"
import style0 from "./myMain.vue?vue&type=style&index=0&id=1ede5c25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ede5c25",
  null
  
)

export default component.exports